// UserManagement Constants
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';

export const GET_ACTIVITY_LOGS = 'GET_ACTIVITY_LOGS';
export const GET_ACTIVITY_LOGS_SUCCESS = 'GET_ACTIVITY_LOGS_SUCCESS';
export const GET_ACTIVITY_LOGS_ERROR = 'GET_ACTIVITY_LOGS_ERROR';

export const GET_USER_ACTIVITY = 'GET_USER_ACTIVITY';
export const GET_USER_ACTIVITY_SUCCESS = 'GET_USER_ACTIVITY_SUCCESS';
export const GET_USER_ACTIVITY_ERROR = 'GET_USER_ACTIVITY_ERROR';

export const GET_ACTIVITY_SUMMARY = 'GET_ACTIVITY_SUMMARY';
export const GET_ACTIVITY_SUMMARY_SUCCESS = 'GET_ACTIVITY_SUMMARY_SUCCESS';
export const GET_ACTIVITY_SUMMARY_ERROR = 'GET_ACTIVITY_SUMMARY_ERROR';

export const CLEAR_USER_MANAGEMENT = 'CLEAR_USER_MANAGEMENT';
